import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { id: "home", label: "Home", index: "00" },
  { id: "philosophy", label: "Philosophy", index: "01" },
  { id: "numbers", label: "Numbers", index: "02" },
  { id: "journey", label: "Journey", index: "03" },
  { id: "casefiles", label: "Case Files", index: "04" },
  { id: "arsenal", label: "Arsenal", index: "05" },
  { id: "credentials", label: "Credentials", index: "06" },
  { id: "contact", label: "Contact", index: "07" }
];

const Header = ({ activeSection }) => {
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/80 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <button
          onClick={() => scrollTo("home")}
          className="font-mono text-sm tracking-widest text-gray-100 hover:text-emerald-400 transition-colors"
          data-testid="header-logo"
        >
          SAURAV<span className="text-emerald-400">.</span>SINHA
        </button>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`font-mono text-xs tracking-widest uppercase transition-colors link-underline ${
                activeSection === item.id ? "text-emerald-400" : "text-gray-400 hover:text-gray-100"
              }`}
              data-testid={`nav-link-${item.id}`}
            >
              <span className="text-emerald-500/60 mr-1">{item.index}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <button
          className="lg:hidden text-gray-100 hover:text-emerald-400 transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden backdrop-blur-xl bg-black/95 border-b border-white/10" data-testid="mobile-nav">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`block w-full text-left px-6 py-4 font-mono text-sm tracking-widest uppercase border-t border-white/5 transition-colors ${
                activeSection === item.id ? "text-emerald-400" : "text-gray-400"
              }`}
              data-testid={`mobile-nav-link-${item.id}`}
            >
              <span className="text-emerald-500/60 mr-2">{item.index}</span>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
